// utils/connectPage.js
//
// ✅ ใหม่ — เชื่อมเพจเข้ากับแอป (ขอ page access token + subscribe webhook ของเพจ) แยกออกมาใช้ร่วมกัน
// ระหว่าง HomeScreen.vue (ตอนเลือกเพจ) และ App.vue (ลองใหม่เบื้องหลังถ้ารอบแรกไม่สำเร็จ)
//
// อาการเดิม: บัญชีใหม่ login ครั้งแรก → กดเลือกเพจแล้ว error "กรุณาลองใหม่ภายหลัง" → รอสักพักกดใหม่ก็เข้าได้
// สาเหตุ: หลังเพิ่งยินยอม permission ครั้งแรก Graph API ตอบ error ชั่วคราวช่วงสั้นๆ และเดิม "ทุกขั้นตอน"
// (รวม /me, /adaccounts ที่ไม่จำเป็นต่อการเข้าร้าน) ต้องผ่านหมดถึงจะให้เข้าแดชบอร์ด
// ตอนนี้: backend ลองใหม่เองเมื่อ error ชั่วคราว (routes/api/facebook.js: withFbRetry) + ถ้ายังไม่สำเร็จ
// ก็ให้เข้าร้านได้ก่อน แล้ว App.vue ลอง subscribe ใหม่เบื้องหลัง (PENDING_KEY)

export const PENDING_KEY = "pendingPageSubscribe";

/** ขอ page token + subscribe webhook — throw ถ้าไม่สำเร็จ (error.step บอกว่าพังขั้นไหน) */
export async function connectPageToApp(http, pageId, fbAccessToken) {
  const base = process.env.VUE_APP_BACKEND_URL;
  let page;
  try {
    page = await http.post(`${base}/api/facebook/pageAccessToken`, { pageId, access_token: fbAccessToken });
  } catch (err) {
    err.step = "pageAccessToken";
    throw err;
  }
  try {
    await http.post(`${base}/api/facebook/subscribed_apps`, { pageId, pageAccessToken: page.data.pageAccessToken });
  } catch (err) {
    err.step = "subscribed_apps";
    throw err;
  }
}

/** ข้อความ error ที่อ่านรู้เรื่อง (ข้อความจาก Facebook/backend ถ้ามี) */
export function describeConnectError(err) {
  const d = err?.response?.data;
  return d?.message || d?.error?.message || err?.message || "ไม่ทราบสาเหตุ";
}

/** token Facebook หมดอายุ/ถูกถอน (ต้อง login ใหม่ ลองซ้ำไม่หาย) */
export function isFacebookAuthError(err) {
  const code = err?.response?.data?.error?.code;
  return code === 190 || code === 102 || err?.response?.status === 401;
}
